import LoginLayout from "@/components/Layout/LoginLayout";
import { SigninWithPassword } from "@/features/auth";
import Head from "next/head";
import type { ReactElement } from "react";

function SigninWithPasswordPage() {
	return (
		<>
			<Head>
				<title>パスワードでログイン | ケアミー</title>
				<meta name="robots" content="noindex" />
			</Head>

			<SigninWithPassword />
		</>
	);
}

SigninWithPasswordPage.getLayout = function getLayout(page: ReactElement) {
	return <LoginLayout>{page}</LoginLayout>;
};

export default SigninWithPasswordPage;
